"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class GLCodeRequest {
}
exports.GLCodeRequest = GLCodeRequest;
//# sourceMappingURL=GLCodeRequest.js.map